import http from '@/utils/http';
const call=async(action,data)=>{const res=await http({url:'/api/admin/v1/contractProjectCarrierDifference/'+action,method:'post',data});if(res?.code!==0)throw Error(res?.msg||res?.message||'承运差额处理失败');return res.data;};
export default {list:data=>call('list',data),settle:data=>call('settle',data)};
